import {
  ParentOrderContextInterface,
  OrderDaysInterface
} from '../../shared/type/parentOrderContext.type';

export const getAvailableMeals = (
  parentOrderContext: ParentOrderContextInterface | undefined,
  consumerId: number | undefined,
  selectedDates: Date[]
): OrderDaysInterface[] => {
  const orderDaysForConsumer = parentOrderContext?.consumerOrderContexts?.find(
    (consumer) => consumer.consumerId === consumerId
  )?.orderDays;

  if (!orderDaysForConsumer) {
    return [];
  }

  const formatDate = (date: Date) => date.toLocaleDateString('en-CA');

  const selectedDatesFormatted = selectedDates.map(formatDate);

  const availableDays = orderDaysForConsumer.filter((orderDay) =>
    selectedDatesFormatted.includes(orderDay.when)
  );

  if (availableDays.length === 0) {
    return [];
  }

  return availableDays;
};
